import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import '../../assets/style/Home.css';
import {
  API_STATUS,
  DEFAULT_OPTION_TRACK_COMPLAINT,
  // POWERBI_IDS,
  footerLinks,
} from '../../utils/Constant';
// import EmbededPowerBi from '../../components/EmbededPowerBI';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { bannerSelector, getBannerAllList } from '../../features/bannerSlice';
import {
  BannerListType,
  EmployeeListItemType,
  GallertListType,
  LatestUpdateResponseType,
  SelectOptionType,
} from '../../utils/Types';
import CenterSpinner from '../../components/CenterSpinner';
import {
  gallerySelector,
  getGalleryAllList,
} from '../../features/gallerySlice';
import {
  getLatestUpdatesAllList,
  latestUpdatesSelector,
} from '../../features/latestUpdatesSlice';
import KPagination from '../../components/KPagination';
import MAutoCompleteWithId from '../../components/MAutoCompleteWithId';
import {
  employeeDataSelector,
  fetchAllEmployeeList,
} from '../../features/employeeDataSlice';
import EmployeeInformationModal from '../modals/EmployeeInformationModal';
import { nameValueGetter } from '../../utils/Util';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useLoader } from '../../loader/LoaderProvider';

const HomePage = () => {
  const { showLoader, setShowLoader } = useLoader();
  const banners: BannerListType[] = useAppSelector(bannerSelector)?.allList;
  const bannerListStatus: string =
    useAppSelector(bannerSelector)?.allListAPIStatus;
  const galleryListStatus = useAppSelector(gallerySelector)?.apiProgressStatus;
  const galleryList: GallertListType[] =
    useAppSelector(gallerySelector)?.allList;
  const dispatch = useAppDispatch();

  const updatesList: LatestUpdateResponseType[] = useAppSelector(
    latestUpdatesSelector
  ).allList.updates;
  const employeeList: EmployeeListItemType[] =
    useAppSelector(employeeDataSelector).employeeList;
  const pagination = useAppSelector(latestUpdatesSelector).allList.pagination;
  const [pageSize, setPageSize] = useState<number>(5);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const latestUpdatesStatus: string = useAppSelector(
    latestUpdatesSelector
  ).allListAPIStatus;
  const [employeeOptions, setEmployeeOptions] = useState<SelectOptionType[]>(
    []
  );
  const [selectedEmployee, setSelectedEmployee] = useState<SelectOptionType>(
    DEFAULT_OPTION_TRACK_COMPLAINT
  );
  const [showEmployeeDetails, setShowEmployeeDetails] =
    useState<boolean>(false);

  useEffect(() => {
    if (
      bannerListStatus === API_STATUS.FAILED ||
      bannerListStatus === API_STATUS.SUCCEEDED ||
      galleryListStatus !== API_STATUS.LOADING ||
      latestUpdatesStatus === API_STATUS.FAILED ||
      latestUpdatesStatus === API_STATUS.SUCCEEDED
    ) {
      setShowLoader(false);
    }
  }, [bannerListStatus, galleryListStatus, latestUpdatesStatus]);

  useEffect(() => {
    dispatch(getBannerAllList({}));
    dispatch(getGalleryAllList());
    dispatch(fetchAllEmployeeList({ pageNumber: 1, pagePerCount: 0 }));
  }, []);

  useEffect(() => {
    dispatch(
      getLatestUpdatesAllList({
        pageNumber: currentPage,
        pagePerCount: pageSize,
      })
    );
  }, [currentPage, pageSize]);

  useEffect(() => {
    const options: SelectOptionType[] = [];
    if (employeeList.length) {
      employeeList?.forEach((item: any) => {
        options.push({
          label: `${nameValueGetter(item)} (${item.employeeUniqueId})`,
          value: item.candidateId,
        });
      });
    }
    setEmployeeOptions(options);
  }, [employeeList]);

  const handleEmployeeOnChange = (employee: any) => {
    setSelectedEmployee(employee);
    if (employee?.value) {
      setShowEmployeeDetails(true);
    }
  };

  return (
    <>
      <div className="border rounded p-3 pt-2">
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div className="col-12 col-md-8 col-lg-6 mb-2">
            <MAutoCompleteWithId
              label=""
              options={employeeOptions}
              onChange={(newValue) => handleEmployeeOnChange(newValue)}
              value={selectedEmployee}
              showIdInOption={false}
              placeholder="Search by Employee Name or Employee ID"
              blurOnSelect
            />
          </div>

          {banners?.length ? (
            <Carousel className="w-100 mb-2">
              {banners.map((banner, index) => (
                <Carousel.Item key={`banner-${banner.homeMediaId}`}>
                  <img
                    className="home-banner "
                    src={banner.homeMediaUrl}
                    alt={`Slide ${index}`}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            ''
          )}
          {/* <div className="w-100 border mt-2 mb-2 home-report">
            <EmbededPowerBi
              groupId={POWERBI_IDS.groupId}
              reportId={POWERBI_IDS.homeReportId}
            />
          </div> */}

          <div className="row w-100 justify-content-between updates-gallery">
            <div className="col-12 col-md-6 col-lg-8 pr-2 overflow-hidden updates-gallery">
              <div className="border p-1 rounded-4">
                <div className=" latest-updates-list">
                  <p className="mt-2 mb-2 fw-bold ">Latest Updates</p>
                  <ul>
                    {updatesList.length ? (
                      updatesList.map((update, index) => (
                        <React.Fragment
                          key={`latest-update-${update.latestUpdateId}`}
                        >
                          <li>
                            <p className="latest-update-description">
                              {update.latestUpdateDescription}
                            </p>
                          </li>
                          {index !== updatesList.length - 1 && (
                            <hr className="m-1" />
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <div className="no-latest-updates">No latest updates</div>
                    )}
                  </ul>
                </div>
                <div className="position-relative">
                  {updatesList.length ? (
                    <KPagination
                      currentPage={pagination?.currentPage}
                      pageSize={pagination?.pageSize}
                      onPageChange={setCurrentPage}
                      onSizeChange={setPageSize}
                      fromItem={pagination?.fromItem}
                      toItem={pagination?.toItem}
                      totalItems={pagination?.totalItems}
                      showSelectLimit={false}
                    />
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 border p-1 rounded-4">
              <p className="mt-2 mb-0 fw-bold">Gallery</p>
              <div className="gallery-carousel">
                {galleryList?.length ? (
                  <Carousel>
                    {galleryList.map((galleryItem, index) => (
                      <Carousel.Item
                        key={`gallery-${galleryItem.galleryMediaId}`}
                      >
                        <img
                          className="gallery-image"
                          src={galleryItem.galleryUrl}
                          alt={`Slide ${index}`}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  <div className="no-latest-updates">No gallery images</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer mt-3 p-2">
        <hr className="m-0" />
        <div className="p-3">
          <div>
            <span>
              <a
                href={footerLinks.termsAndConditions}
                target="_blank"
                rel="noopener noreferrer"
                className=" social-media-icons"
              >
                Terms and Conditions
              </a>
            </span>
            {' | '}
            <span>
              <a
                href={footerLinks.contactUs}
                target="_blank"
                rel="noopener noreferrer"
                className="social-media-icons"
              >
                Contact
              </a>
            </span>
          </div>
          <div className="pt-2">
            <span>
              {'Email: '}
              <a href="mailto:Info@Kshema.co" className="social-media-icons">
                Info@Kshema.co
              </a>
            </span>
            {' | '}
            <span>
              {'Phone: '}
              <a
                href="tel:18005723013"
                className="text-decoration-none social-media-icons"
              >
                1800 572 3013
              </a>
            </span>
          </div>
          <div className="pt-2">
            <div className="d-flex gap-1">
              <a
                href={footerLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookRoundedIcon
                  fontSize="medium"
                  className="social-media-icons"
                />
              </a>

              <a
                href={footerLinks.youtube}
                target="_blank"
                rel="noopener noreferrer"
              >
                <YouTubeIcon fontSize="medium" className="social-media-icons" />
              </a>
              <a
                href={footerLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon
                  fontSize="medium"
                  className="social-media-icons"
                />
              </a>
              <a
                href={footerLinks.instragram}
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon
                  fontSize="medium"
                  className="social-media-icons"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <CenterSpinner showLoader={showLoader} />

      {showEmployeeDetails && (
        <EmployeeInformationModal
          isOpen={showEmployeeDetails}
          candidateId={Number(selectedEmployee.value)}
          toggleModal={() => {
            setSelectedEmployee(DEFAULT_OPTION_TRACK_COMPLAINT);
            setShowEmployeeDetails(false);
          }}
          readOnly
        />
      )}
    </>
  );
};

export default HomePage;
